<template functional>
  <svg width="13" height="15" viewBox="0 0 13 15" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M2.66667 1H6.5C6.77614 1 7 0.776142 7 0.5C7 0.223858 6.77614 0 6.5 0H2.66667C1.19391 0 0 1.11929 0 2.5V12.5C0 13.8807 1.19391 15 2.66667 15H6.5C6.77614 15 7 14.7761 7 14.5C7 14.2239 6.77614 14 6.5 14H2.66667C1.78301 14 1 13.3284 1 12.5V2.5C1 1.67157 1.78301 1 2.66667 1Z"
          fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M9.84675 10.8608L12.8613 7.83608C13.0462 7.65047 13.0462 7.34953 12.8613 7.16392L9.84675 4.13921C9.66177 3.9536 9.36185 3.9536 9.17686 4.13921C8.99188 4.32482 8.99188 4.62576 9.17686 4.81137L11.3827 7.02471L4 7.02471L4 7.97529L11.3827 7.97529L9.17686 10.1886C8.99188 10.3742 8.99188 10.6752 9.17686 10.8608C9.36185 11.0464 9.66177 11.0464 9.84675 10.8608Z"
          fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconLogout"
}
</script>

<style scoped>

</style>